<div class="modal-header">
  <h1 class="modal-title">
    Where do you want to move <span class="title-name">{{source.data.name}}</span>?
  </h1>
  <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
</div>
<div class="modal-body">
  <app-add-edit-destinations [source]='source' (sendDestinationToParent)='handleDestination($event)'>
  </app-add-edit-destinations>
  <small class="text-error w-100 d-flex" *ngIf='validation'> destination is mandatory. please choose one</small>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="onDelete()">Cancel</button>
  <button class="btn btn-default ml-3" type='button' (click)="onSubmit()"
    [ngClass]="{'btn-disabled disabled': !this.selected }">Move</button>
</div>